import { Link } from 'react-router'
import { ServiceCard } from '@/components/sv'
import { useCompanyPath } from '@/lib/hooks'

type Props = {
  templateInstance: any
  service: any
}

export const TemplateDbCard = ({ templateInstance, service }: Props) => {
  const { getCompanyPath } = useCompanyPath()
  const instanceService = templateInstance?.services.find(
    (s: any) => s.serviceName === service.name
  )
  const databaseName = instanceService?.name ?? ''
  const infoText =
    instanceService?.status === 'created'
      ? 'Provisioning'
      : instanceService?.status === 'readyForConnections'
        ? 'Ready'
        : 'Failed to provision'
  const info = (
    <div className="flex items-center gap-2">
      {instanceService?.status ? (
        <>
          <span>{infoText}</span>
          <span> — </span>
        </>
      ) : null}
      {service.serviceType === 'databaseMariaDB'
        ? 'MariaDB'
        : service.serviceType === 'databaseMySQL'
          ? 'MySQL'
          : service.serviceType === 'databasePostgresql'
            ? 'PostgreSQL'
            : service.serviceType === 'databaseRedis'
              ? 'Redis'
              : service.serviceType === 'databaseValkey'
                ? 'Valkey'
                : null}{' '}
      {service.dbVersion}
    </div>
  )

  const DatabaseCard = () => (
    <ServiceCard
      key={service.id}
      type="db"
      disabled={!instanceService?.status}
      status={
        instanceService?.status === 'created'
          ? 'creating'
          : instanceService?.status === 'readyForConnections'
            ? 'ready'
            : 'deploymentCancelled'
      }
      name={service.displayName}
      info={info}
    />
  )

  if (instanceService?.status) {
    return (
      <Link
        to={getCompanyPath({
          pathname: '/database/:databaseName/overview',
          variables: { databaseName },
        })}
      >
        <DatabaseCard />
      </Link>
    )
  } else {
    return <DatabaseCard />
  }
}
